import axios from "axios";
import { Img } from "components/Img";
import { Field } from "formik";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import OccasionCard from "./OccasionCard";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "30rem",
        minHeight: "25rem",
        maxHeight: "25rem",
        borderRadius: "1.5em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "1.3em",
        background: "white",
        // background:
        //   "linear-gradient(120deg, #C7366B 10%, #9F33AC 50%, #8532D7 90%)",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: 999,
    },
};

const getModalStyles = () => {
    if (window.matchMedia("(max-width: 768px)").matches) {
        // Apply smaller styles for mobile and tablet
        return {
            ...customStyles,
            content: {
                ...customStyles.content,
                width: "90%", // Set to a percentage or auto
            },
        };
    }
    // Default styles for larger screens
    return customStyles;
};

const NotificationCard = ({ disable, element, name, onChange }:any) => {
    const [loader, setLoader] = useState(false);
    const [modal, setModal] = useState(false);
    const [festivals, setFestivals] = useState([]);
    const fetchData = async () => {
        try {
            setLoader(true);
            const response = await axios.get(`https://dev.soomuch.ai/api/v1/master/masterEvent/list?event_type=DAILY`);
            setFestivals(festivals => (response?.data?.data?.["Master Events"] || response?.data?.data));
        } catch (err) { } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        if (modal) {
            fetchData();
        }
    }, [modal]);

    return (
        <div>
            <Modal
                isOpen={modal}
                contentLabel="Example Modal"
                style={getModalStyles()}
            >
                <div className="min-h-[22rem] flex flex-col justify-between">
                    <div className="min-h-[19rem] max-h-[19rem] overflow-auto space-y-4 border border-solid">
                        <div className='flex flex-col justify-center items-center'>
                            {loader ? <Img src={"/images/loader.gif"} className="w-10 h-10 mb-2" /> : <div className="flex flex-1 flex-wrap justify-center gap-4 p-2">
                                {festivals.map((option, index) => <OccasionCard
                                    key={"asdasdasdasdOssccasionsasdsad" + index}
                                    element={option}
                                    name={`occasions[${index}].IS_OPTED`}
                                />)}
                            </div>}
                        </div>
                    </div>
                    <button onClick={() => setModal(false)} type="button" className="w-full bg-purple-primary text-[white] p-2 rounded-lg">Close</button>
                </div>
            </Modal>
            <div className="rounded-lg shadow-lg px-2 py-1 flex flex-col gap-2 h-full shadow-2xl border border-solid">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <span className="text-[2.2vh] font-medium">{element?.title || "Name"}</span>
                    </div>
                    <div className="flex gap-4 items-center">
                        {!!element?.viewModalButton && <button onClick={() => setModal(true)} className="text-[2.2vh] font-manropeSB text-purple-primary" type="button">View All</button>}
                        <label>
                            <Field
                                type="checkbox"
                                name={name}
                                checked={element.checked}
                                className="p-2 rounded  border border-solid"
                                onChange={e => {
                                    if(!disable) {
                                        onChange(e);
                                    }
                                }}
                            />
                        </label>
                    </div>
                </div>
                <hr />
                {!!element?.description && <p className="text-[2vh] text-[gray] mb-2">{element?.description}</p>}
            </div>
        </div >
    );
}

export default NotificationCard;